import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState, useEffect } from 'react';
import axios from 'axios';

var ExhibitionSearch = function ExhibitionSearch() {
  var _useState = useState(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      exhibitions = _useState2[0],
      setExhibitions = _useState2[1]; // const [artists, setArtists] = useState(undefined);
  // const [artistCheatSheet, setArtistCheatSheet] = useState(undefined);


  var _useState3 = useState(undefined),
      _useState4 = _slicedToArray(_useState3, 2),
      searchTerm = _useState4[0],
      setSearchTerm = _useState4[1];

  var getExhibitions = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return axios.get("/wp-json/wp/v2/exhibitions?per_page=100&filter[orderby]=menu_order&_embed").then(function (res) {
                return res.data;
              });

            case 2:
              response = _context.sent;
              console.log("response for Exhibitions", response);
              return _context.abrupt("return", response);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getExhibitions() {
      return _ref.apply(this, arguments);
    };
  }();

  var getEndpoint = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(url) {
      var response;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return axios.get(url).then(function (res) {
                return res.data;
              });

            case 2:
              response = _context2.sent;
              return _context2.abrupt("return", response);

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function getEndpoint(_x) {
      return _ref2.apply(this, arguments);
    };
  }(); // Not Currently Used
  // const getArtists = async () => {
  //     const response = await axios
  //         .get(`/wp-json/wp/v2/artist?per_page=100&filter[orderby]=menu_order&_embed`)
  //         .then((res) => res.data);
  //     console.log(`response for Artists`, response);
  //     return response;
  // };


  var fetchExhibitions = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var myExhibitions;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return getExhibitions();

            case 2:
              myExhibitions = _context3.sent;
              console.log('myExhibitions', myExhibitions);
              setExhibitions(myExhibitions);

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function fetchExhibitions() {
      return _ref3.apply(this, arguments);
    };
  }();

  var fetchSearch = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(searchQuery) {
      var url, myResults, newExhibitions;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              url = "/wp-json/wp/v2/search?type=post&per_page=100&subtype=exhibitions&search=".concat(searchQuery);
              _context5.next = 3;
              return getEndpoint(url);

            case 3:
              myResults = _context5.sent;
              newExhibitions = [];
              _context5.next = 7;
              return Promise.all(myResults.map( /*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(result) {
                  var newLink, newResult;
                  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          console.log('result', result);
                          newLink = "".concat(result._links.self[0].href, "?_embed");
                          _context4.next = 4;
                          return getEndpoint(newLink);

                        case 4:
                          newResult = _context4.sent;
                          console.log('newResult', newResult);
                          newExhibitions.push(newResult);

                        case 7:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                }));

                return function (_x3) {
                  return _ref5.apply(this, arguments);
                };
              }()));

            case 7:
              console.log('newExhibitions', newExhibitions);
              setExhibitions(newExhibitions);

            case 9:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function fetchSearch(_x2) {
      return _ref4.apply(this, arguments);
    };
  }(); // Not currently used
  // const fetchArtists = async () => {
  //     console.log('debug fetchArtists is run')
  //     const allArtists = await getArtists();
  //     console.log('debug allArtists', allArtists);
  //     setArtists(allArtists);
  //     const artistArray = []
  //     if (allArtists.length){
  //         allArtists.forEach(artist => {
  //             if (artist && artist.id && artist.id > 0){
  //                 console.log(`debug artist ${artist.id} is:`, artist);
  //                 artistArray[artist.id] = artist;
  //             }
  //         })
  //     }
  //     console.log('artistArray', artistArray);
  //     setArtistCheatSheet(artistArray);
  // }


  var watchSearch = function watchSearch() {
    var searchInput = document.querySelector('.headline-wrapper form input');
    var searchButton = document.querySelector('.headline-wrapper form button');
    searchButton.addEventListener('click', function (e) {
      e.preventDefault();

      if (searchInput.value) {
        setSearchTerm(searchInput.value);
        fetchSearch(searchInput.value);
        setTimeout(function () {
          placeholderHeight();
        }, 500);
      } else {
        setSearchTerm(undefined);
        fetchExhibitions();
        setTimeout(function () {
          placeholderHeight();
        }, 500);
      }
    });
  };

  var placeholderHeight = function placeholderHeight() {
    var placeholder = document.querySelector('.parallax-placeholder');
    var container = document.querySelector('.exhibition-container.parallax');
    placeholder.style.height = "".concat(container.offsetHeight, "px");
  };

  useEffect( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return fetchExhibitions();

          case 2:
            watchSearch();
            setTimeout(function () {
              placeholderHeight();
            }, 100);

          case 4:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  })), []);

  var returnArtists = function returnArtists(exhibition) {
    var artistIds = [];
    exhibition.acf.flex_content.map(function (content) {
      if (content.acf_fc_layout === 'bio') {
        content.artists.forEach(function (artist) {
          artistIds.push(artist.artist);
        });
      }
    });
    return artistIds;
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "wrapper react-wrapper-container",
    "data-result-count": exhibitions ? exhibitions.length : '0'
  }, exhibitions !== undefined && exhibitions.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "progress-bar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "progress"
  })), exhibitions !== undefined && exhibitions.length === 0 && searchTerm !== undefined && /*#__PURE__*/React.createElement("p", null, "No results found for ", searchTerm), /*#__PURE__*/React.createElement("div", {
    className: "exhibition-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, exhibitions && exhibitions.map(function (exhibition) {
    var artistIds = returnArtists(exhibition);
    var excerpt = exhibition.excerpt.rendered;
    var truncated = excerpt.replace(/^(.{250}[^\s]*).*/, "$1");

    if (excerpt !== truncated) {
      excerpt = truncated + '...';
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "exhibition-card",
      key: "exhibition-".concat(exhibition.id)
    }, /*#__PURE__*/React.createElement("div", {
      className: "image-container load"
    }, exhibition._embedded && /*#__PURE__*/React.createElement("img", {
      src: exhibition._embedded["wp:featuredmedia"][0]["media_details"]["sizes"]['medium']['source_url'],
      alt: exhibition["_embedded"]["wp:featuredmedia"][0]["alt_text"],
      loading: "lazy"
    })), /*#__PURE__*/React.createElement("div", {
      className: "text-container"
    }, /*#__PURE__*/React.createElement("h3", null, exhibition.title.rendered), exhibition.acf.page_subtitle && /*#__PURE__*/React.createElement("p", {
      className: "attribution"
    }, exhibition.acf.page_subtitle), /*#__PURE__*/React.createElement("p", {
      className: "description",
      dangerouslySetInnerHTML: {
        __html: excerpt
      }
    }), /*#__PURE__*/React.createElement("a", {
      href: exhibition.link
    }, "View Installation ", /*#__PURE__*/React.createElement("img", {
      src: "/app/themes/ej-theme/resources/assets/images/ui-elements/circle-arrow.svg",
      alt: "",
      "aria-hidden": "true"
    }))));
  }))));
};

export default ExhibitionSearch;


// WEBPACK FOOTER //
// ./scripts/react/components/ExhibitionSearch.js